import { Menu as MuiMenu, MenuProps as MuiMenuProps, MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps, Typography } from '@mui/material';
import { forwardRef } from 'react';

export interface MenuProps extends Omit<MuiMenuProps, 'sx'> {
  sx?: MuiMenuProps['sx'];
}

export const Menu = forwardRef<HTMLDivElement, MenuProps>(({ sx, MenuListProps, ...props }, ref) => {
  return (
    <MuiMenu
      ref={ref}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      sx={{
        '.MuiPaper-root': {
          background: 'white',
          borderRadius: '8px',
          border: '1px solid var(--Gray-100, #F2F4F7)',
          boxShadow: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
        },
        ...sx,
      }}
      MenuListProps={{
        sx: {
          paddingTop: 0,
          paddingBottom: 0,
          ...MenuListProps?.sx,
        },
        ...MenuListProps,
      }}
      {...props}
    />
  );
});

Menu.displayName = 'Menu';

export interface MenuItemProps extends MuiMenuItemProps {
  icon?: React.ReactNode | string;
}

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(({ icon, onClick, children, sx, ...props }, ref) => {
  return (
    <MuiMenuItem
      ref={ref}
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        height: '40px',
        ...sx,
      }}
      {...props}
    >
      {typeof icon === 'string' ? <i className={icon} style={{ fontSize: '16px', color: '#667085' }} /> : icon}
      <Typography
        style={{
          color: 'var(--Gray-700, #344054)',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
        }}
      >
        {children}
      </Typography>
    </MuiMenuItem>
  );
});

MenuItem.displayName = 'MenuItem';
